import { api, formDataApi } from "./api";

export const getReferenceList = async (page: number, size: number) => {
  try {
    const params = { page, size }
    const { data } = await api().get('/reference', { params });
    return data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getReferenceData = async (id: number) => {
  try {
    const { data } = await api().get(`/reference/${id}`);
    return data.data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const registerReference = async (title: string, content: string, files: File[]) => {
  try {
    const formData = new FormData();
    const requestObj = { title, content };
    formData.append(
      'request', 
      new Blob([JSON.stringify(requestObj)], { type: 'application/json' })
    );
    files.forEach((file) => {
      formData.append('files', file);
    });
    const { data } = await formDataApi().post('/reference/register', formData);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const updateReference = async (id: number, title: string, content: string, files: File[]) => {
  try {
    const formData = new FormData();
    const requestObj = { id, title, content };
    formData.append(
      'request', 
      new Blob([JSON.stringify(requestObj)], { type: 'application/json' })
    );
    files.forEach((file) => {
      formData.append('files', file);
    });
    const { data } = await formDataApi().post('/reference/update', formData);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const deleteReference = async (id: number) => {
  try {
    const params = { id };
    const { data } = await api().post('/reference/delete', null, { params });
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const deleteFile = async (fileId: number) => {
  try {
    const params = { fileId };
    console.log(fileId);
    const { data } = await api().post('/reference/file/delete', null, { params });
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const downloadFile = async (fileId: number) => {
  try {
    const params = { fileId };
    const { data } = await api().get('/reference/file/download', { params, responseType: "blob" });
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};